// extracted by mini-css-extract-plugin
module.exports = {"shape":"Shape_shape__o7M9W","green":"Shape_green__2VbAW","red":"Shape_red__2kiT0","orange":"Shape_orange__V2GTa"};